import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Portfolio from './pages/Portfolio';
import { Toaster } from './components/ui/toaster';
import { ThemeProvider } from './context/ThemeContext';

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <HashRouter>
          <Routes>
            <Route path="/" element={<Portfolio />} />
            <Route path="*" element={<Portfolio />} />
          </Routes>
        </HashRouter>
        <Toaster />
      </div>
    </ThemeProvider>
  );
}

export default App;